import type { CustomerSelectProps } from '@ztechapps/webui.contract'
import { UserSelect } from '@ztechapps/webui.input'
import { teacherDataLoadOptions } from './teacherDataLoadOptions'

// Bound to `customerSelectCreatable` and `contactSelect`: a QuickScore
// requester or recipient is always a registered teacher, so the shared customer picker props that
// only describe the customer lookup (`showInfo`, `As`, `filter`) are dropped and the teacher name
// search drives the options. `form` / `meta` from the Formik `Field` are discarded by SelectAsync.
export const TeacherSelect = ({ showInfo: _showInfo, As: _As, filter: _filter, ...rest }: CustomerSelectProps) => (
  <UserSelect {...rest} dataLoadOptions={teacherDataLoadOptions} />
)
